class ContentVideoBlock extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video') || false;
    this.button = this.querySelector('#playbutton') || false;
    this.mutebutton = this.querySelector('#mutebutton') || false;
    this.init();
    this.video.addEventListener('ended', this.reset.bind(this), false);
  }

  init() {
    if (this.button) {
      this.button.addEventListener('click', this.togglePlayPause.bind(this));
    }
    if (this.mutebutton) {
      this.mutebutton.addEventListener('click', this.toggleMuteUnmute.bind(this));
    }
  }

  togglePlayPause() {
    if (this.video.paused) {
      this.video.play();
      this.button.classList.add('playing');
      this.button.firstElementChild.innerText = 'Pause';

      this.video.muted = false;
      this.videoMutedState = false;
      this.mutebutton.classList.remove('hidden');
      this.mutebutton.classList.add('flex');

      return;
    }

    this.video.pause();
    this.button.classList.remove('playing');
    this.button.firstElementChild.innerText = 'Play';

    this.mutebutton.classList.remove('flex');
    this.mutebutton.classList.add('hidden');
  }

  toggleMuteUnmute() {
    if (this.videoMutedState === false) {
      this.video.muted = true;
      this.mutebutton.querySelectorAll('svg').forEach((svg) => svg.classList.toggle('hidden'));
      this.videoMutedState = true;
      return;
    }

    this.video.muted = false;
    this.videoMutedState = false; // Update videoMutedState
    this.mutebutton.querySelectorAll('svg').forEach((svg) => svg.classList.toggle('hidden'));
  }

  reset() {
    this.button.classList.remove('playing');
    this.mutebutton.classList.add('foo');
    this.button.firstElementChild.innerText = 'Play';
  }
}

customElements.define('content-video-block', ContentVideoBlock);

class ContentImageCarousel extends HTMLElement {
  constructor() {
    super();

    this.className = this.className.replace('no-js', 'js');

    if (is_touch_enabled()) {
      this.className = this.className.replace('no-touch', 'is-touch');
    }

    window.Alpine.initTree(this);
  }
}

customElements.define('content-image-carousel', ContentImageCarousel);
